import { render, staticRenderFns } from "./Responsaveis.vue?vue&type=template&id=b7dd7d3a&scoped=true&"
import script from "./Responsaveis.vue?vue&type=script&lang=js&"
export * from "./Responsaveis.vue?vue&type=script&lang=js&"
import style0 from "./Responsaveis.vue?vue&type=style&index=0&id=b7dd7d3a&lang=scss&scoped=true&"
import style1 from "./Responsaveis.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dd7d3a",
  null
  
)

export default component.exports